import { UIComponentViewImpl } from '../uicomponentview';
import { UIDataModel } from '../uicomponent';
import { ToolbarComponentProps, ToolbarComponentHandler, ToolbarComponentState } from './toolbarcomponent';
import { ToolbarCSSStyle } from './toolbarcss';
import * as React from 'react';
import { Strings } from '../../../utils/resources/strings';
import { CategoryDto } from '../../../core/dto/categories/categorydto';
import { CategoriesCardComponent } from '../../components/home/categories/viewmodel/categoriescard/categoriescardcomponent';

export class ToolbarViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onLogoClicked = this.onLogoClicked.bind(this);
        this.onSignInClicked = this.onSignInClicked.bind(this);
        this.onDoItYouselfClicked = this.onDoItYouselfClicked.bind(this);
        this.onCategorySelected = this.onCategorySelected.bind(this);
        this.showTunesOption = this.showTunesOption.bind(this);
        this.hideTunesOption = this.hideTunesOption.bind(this);
        this.onFlashMessageClicked = this.onFlashMessageClicked.bind(this);
    }

    draw(props: ToolbarComponentProps, state: ToolbarComponentState, cssStyle: ToolbarCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);
        
       return (
           <>
             <div style={cssStyle.getToolbarContainerCSSStyle()}>
                    {/* <img onClick={this.onLogoClicked} src={props.context.getResources().getImage("mpt_logo.svg")} style={cssStyle.getIconCSSStyle()} /> */}
                    <div style={cssStyle.getTitleDivCSSStyle()} onClick={this.showTunesOption}>
                        <label style={cssStyle.getTitleCSSStyle(false)}>{props.context.getResources().getString(Strings.tunes)}</label>
                        <img  style={{width:'10px', cursor: "pointer",marginLeft:'7px',height:'6px'}} src={this.getContext().getResources().getImage("down_arrow_gray.svg")}/>
                    </div>
                    <div style={cssStyle.getFlashMessageDivCSSStyle()} onClick={this.onFlashMessageClicked}>
                        <label style={cssStyle.getTitleCSSStyle(false)}>{props.context.getResources().getString(Strings.flash_message)}</label>
                    </div>
                    {/* <div style={cssStyle.getTitleDivCSSStyle()} onClick={this.onSalathiClicked}>
                        <label style={cssStyle.getTitleCSSStyle(false)}>{props.context.getResources().getString(Strings.salati)}</label>
                    </div> */}
                    {/* <div style={cssStyle.getTitle2DivCSSStyle()} onClick={this.onDoItYouselfClicked}>
                        <label style={cssStyle.geDoItYouselfCSSStyle()}>{props.context.getResources().getString(Strings.doityourself)}</label>
                    </div> */}
                     {
                     !props.context.getUserContext().getIsLoggedIn() && 
                      <>
                         <div style={{marginLeft:'auto',marginRight:'15px'}}>
                            <label onClick={this.onSignInClicked} style={cssStyle.getSignUpCSSStyle()}>{props.context.getResources().getString(Strings.signin)}</label>
                         </div>
                        </>
                    }
             </div>
             {
                 state.isTunesSelected &&
                <div onMouseLeave={this.hideTunesOption} style={cssStyle.getTunesDropDownSSStyle()}>
                {
                    state.categories.map((t: CategoryDto, position: number) =>
                    {
                        return <CategoriesCardComponent key={position} onSelected={this.onCategorySelected} context={this.getContext()} categoryDto={t}  position={position}/>;
                    })
                }
                </div>}
               
             </>
       );
    }

    onCategorySelected(categoryDto: CategoryDto): void
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).deselectAll();
        (this.getUIComponentHandler() as ToolbarComponentHandler).onCategoriesSelected(categoryDto.getTitle());
    }

    private showTunesOption() 
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).onTunesSelected(true);
    }
    
    private hideTunesOption()
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).onTunesSelected(false);
    }

    private onLogoClicked()
    {
        (this.getUIProps() as ToolbarComponentProps).onLogoClicked();
    }

    private onSignInClicked()
    {
        (this.getUIComponentHandler() as ToolbarComponentHandler).onSignInClicked();
    }

    private onDoItYouselfClicked()
    {
        (this.getUIProps() as ToolbarComponentProps).onDoItYourselfClicked();
    }

   
    private onFlashMessageClicked()
    {
        (this.getUIProps() as ToolbarComponentProps).onFlashMessageClicked();
    }
    // private onSalathiClicked()
    // {
    //     (this.getUIProps() as ToolbarComponentProps).onSalathiClicked();
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toolbar/toolbarview.tsx